import { Component, type ReactNode } from 'react';
import { Alert, Button } from 'antd';

interface State { hasError: boolean; error?: Error; }

export class ErrorBoundary extends Component<{ children: ReactNode; label?: string }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('[ErrorBoundary]', this.props.label, error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert
          type="error"
          showIcon
          message={`Помилка рендеру${this.props.label ? `: ${this.props.label}` : ''}`}
          description={
            <div>
              <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11, margin: 0 }}>
                {this.state.error?.stack ?? this.state.error?.message ?? String(this.state.error)}
              </pre>
              <Button
                size="small"
                style={{ marginTop: 8 }}
                onClick={() => this.setState({ hasError: false, error: undefined })}
              >
                Спробувати знову
              </Button>
            </div>
          }
        />
      );
    }
    return this.props.children;
  }
}
